module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "600px"
    },
    model: {
      value: (_vm.dialogTermoLegal),
      callback: function($$v) {
        _vm.dialogTermoLegal = $$v
      },
      expression: "dialogTermoLegal"
    }
  }, [_c('div', {
    staticClass: "link",
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("Termos legais")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Termos legais")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n      Os serviços oferecidos neste site, bem como suas marcas, sistemas,\n      conteúdo são protegidos por direitos de propriedade intelectual."), _c('br'), _vm._v("\n\n      Nosso maior objetivo é oferecer um excelente serviço pela Internet e,\n      por isso, poderemos cancelar o cadastro de usuários que venham a\n      prejudicar, de alguma forma, o bom funcionamento do site. Portanto,\n      fica esclarecido que é expressamente proibida a comercialização,\n      reprodução, modificação ou distribuição, de parte ou totalidade das\n      informações e todo o conteúdo contido neste site, sem prévia\n      autorização."), _c('br'), _vm._v("\n\n      Constitui também infração, qualquer uso do site com propósitos ilegais,\n      propagação de vírus de computador ou envio de falsificação de endereços\n      de máquinas ou de correio eletrônico, na tentativa de ocultar a\n      identidade ou autoria, ou de responsabilizar terceiros."), _c('br'), _vm._v("\n\n      Todo o conteúdo do site, caso seja necessário, poderá ser alterado ou\n      cancelado a qualquer momento sem aviso prévio."), _c('br'), _vm._v("\n\n      Com relação ao uso dos \"links\" apresentados no site, é importante\n      salientar que não nos responsabilizamos pelos conteúdos contidos ou\n      fornecidos por estes sites, nem por eventuais prejuízos ou danos\n      causados pelos mesmos."), _c('br'), _vm._v("\n\n      As informações aqui publicadas são passíveis de alterações a qualquer\n      tempo, sem prévia notificação do usuário. Para efeito legal, prevalece\n      o documento original."), _c('br'), _vm._v("\n\n      Nós não nos responsabilizamos por prejuízos da utilização ou não deste\n      site.\n    ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogTermoLegal = false
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bf6d690","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/TermoLegal.vue
// module id = 728
// module chunks = 5